// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-slide-active[data-v-0680cae1]{opacity:1 !important}@media(min-width: 768px){.swiper-slide-active i[data-v-0680cae1]{display:flex !important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
